"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CAROUSEL_INDICATOR_PLACEMENT = exports.CAROUSEL_DIRECTION = exports.CAROUSEL_BACKGROUND = exports.CAROUSEL_ARROW_PLACEMENT = void 0;
const CAROUSEL_DIRECTION = exports.CAROUSEL_DIRECTION = ['horizontal', 'vertical'];
const CAROUSEL_INDICATOR_PLACEMENT = exports.CAROUSEL_INDICATOR_PLACEMENT = ['bottom', 'top', 'start', 'end'];
const CAROUSEL_ARROW_PLACEMENT = exports.CAROUSEL_ARROW_PLACEMENT = ['page-indicator', 'content'];
const CAROUSEL_BACKGROUND = exports.CAROUSEL_BACKGROUND = ['transparent', 'solid', 'translucent'];